
import { useLocation, useSearchParams, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import ExternalRedirect from "../components/utility/ExternalRedirect";
import { redirectToOmoduduwa } from "../App";

const NotFound = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const referrer = searchParams.get('referrer');
  const currentUrl = typeof window !== 'undefined' ? window.location.href : '';
  
  // Execute immediate check for the special pattern
  useEffect(() => {
    const checkForSpecialPattern = () => {
      // The specific target URL pattern we're looking for
      const targetPattern = '21d11b63-7b91-46fa-8c91-a30744574195';
      
      // Check both the URL and the referrer parameter
      if (currentUrl.includes(targetPattern) || referrer === targetPattern) {
        console.log("NotFound: DIRECT URL MATCH! Executing redirect now...");
        // Use window.location.replace for a full page redirect
        window.location.replace('https://www.omooduduwa.org/join');
        return true;
      }
      
      return false;
    };
    
    // Execute immediately
    const redirected = checkForSpecialPattern();
    
    // Also set up a recurring check to handle edge cases
    if (!redirected) {
      const intervalCheck = setInterval(() => {
        const redirected = checkForSpecialPattern();
        if (redirected) clearInterval(intervalCheck);
      }, 500);
      
      return () => clearInterval(intervalCheck);
    }
  }, [currentUrl, referrer, location.pathname, searchParams]);

  // Check if this is the specific URL we need to redirect - make it domain-agnostic
  const isTargetUrl = (currentUrl.includes('/join') || location.pathname === '/join') && 
                     (referrer === '21d11b63-7b91-46fa-8c91-a30744574195' || 
                      currentUrl.includes('21d11b63-7b91-46fa-8c91-a30744574195'));

  // Handle special redirect case for our target URL
  if (isTargetUrl) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <p className="text-xl text-gray-600 mb-4">Redirecting you to www.omooduduwa.org/join...</p>
          {/* Script to force redirect even if React fails */}
          <script dangerouslySetInnerHTML={{ 
            __html: `
              window.location.replace('https://www.omooduduwa.org/join');
            `
          }} />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">Oops! Page not found</p>
        <a href="/" className="text-blue-500 hover:text-blue-700 underline">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
